import Colors from '@/theme/constants/Colors';
import { TableRow, styled } from '@mui/material';

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  borderBottom: `2px solid ${Colors.COLOR_WHITE_2}80`,
  '&:last-child td, &:last-child th': { borderBottom: 'none !important' },
}));
